import React, { Component } from 'react'

import PropTypes from 'prop-types'
import FICTooltip from 'FICTooltip'
import FICNumbers from 'FICNumbers'
import FAIcon from 'FAIcon'

import '../css/FICInputText.css'

class FICInputText extends Component {
  constructor (props) {
    super(props)
    this.textInput = null
    this.leftText = null
    this.rightText = null
    this.scheduledChange = null
    this.lastOnChangeValue = props.value || undefined
    this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined,
      clearableVisible: props.clearable && props.value
      // allowAutoFocusChange: true,
    }
  }

  /*
  static getDerivedStateFromProps(nextProps, prevState) {
    console.log(nextProps, prevState)
    if (nextProps.autoFocus && prevState.allowAutoFocusChange && nextProps.value !== prevState.internalValue && !prevState.internalValue) {
      return Object.assign({}, prevState, { internalValue: nextProps.value, allowAutoFocusChange: false })
    }
    return null
  }
  */

  componentDidMount () {
    if (this.props.autoFocus) {
      setTimeout(() => {
        this.focus()
        setTimeout(() => {
          this.setState({ useInternalValue: false })
        }, 0)
      }, 100)
    }
    if (this.textInput && this.leftText) { this.textInput.style.paddingLeft = this.leftText.getBoundingClientRect().width + 12 + 'px' }
    if (this.textInput && this.rightText) { this.textInput.style.paddingRight = this.rightText.getBoundingClientRect().width + 12 + 'px' }
  }

  focus () {
    if (this.textInput) {
      this.textInput.focus()
    }
  }

  blur () {
    if (this.textInput) {
      this.textInput.blur()
    }
  }

  nextInput () {
    let inputs = $(':input')
    let nextInput = inputs.get(inputs.index(this.textInput) + 1)
    if (nextInput) {
      nextInput.focus()
    }
  }

  uncontrolledGetValue () {
    return this.textInput.value
  }

  uncontrolledSetValue (value) {
    this.textInput.value = value
  }

  shouldUseInternalValue = () => {
    return this.props.changeOnBlur || (!this.props.uncontrolled && this.props.changeDelay)
  }

  getDisplayValue = () => {
    const props = this.props
    const state = this.state
    return props.uncontrolled ? undefined
      : this.shouldUseInternalValue() && state.useInternalValue ? (state.internalValue || '')
        : props.transform ? props.transform(props.value)
          : props.value != null ? props.value
            : ''
  }

  handleChange = (e) => {
    const props = this.props
    const value = e.target.value
    // this.setState({ allowAutoFocusChange: false })
    if (props.clearable) {
      this.setState({ clearableVisible: value })
    }
    if (this.shouldUseInternalValue()) {
      this.setState({ internalValue: value, useInternalValue: true })
    }
    if (props.changeDelay) {
      if (this.scheduledChange) {
        clearTimeout(this.scheduledChange)
      }
      this.scheduledChange = setTimeout(() => {
        this.executeOnChange(value)
      }, props.changeDelay)
    } else {
      this.executeOnChange(value)
    }
  }

  executeOnChange = (value) => {
    const props = this.props
    if (props.onChange && (value !== this.lastOnChangeValue || value !== props.value)) {
      this.lastOnChangeValue = value
      props.onChange(props.name, value, null, 'text')
    }
  }

  handleFocus = (e) => {
    const props = this.props
    if (this.shouldUseInternalValue()) {
      this.setState({
        useInternalValue: true,
        internalValue: props.value
      })
    }
    if (props.onFocus) {
      props.onFocus(e)
    }
  }

  handleBlur = (e) => {
    const props = this.props
    const value = e.target.value
    this.setState({ useInternalValue: false })
    if (props.changeOnBlur) {
      this.executeOnChange(value)
    }
    if (props.onBlur) {
      props.onBlur(e)
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.textInput && this.leftText) { this.textInput.style.paddingLeft = this.leftText.getBoundingClientRect().width + 12 + 'px' }
    if (this.textInput && this.rightText) { this.textInput.style.paddingRight = this.rightText.getBoundingClientRect().width + 12 + 'px' }
  }

  render () {
    let { leftIcon, leftIconClick, leftText, rightIcon, rightIconClick, rightText, style, clearable, onChange, ...props } = this.props
    const FICInputTextTag = props.type === 'multiline' ? 'textarea' : 'input'
    // Class name
    let className = 'fic-input-text-input'
    if (props.validator && !props.validator.valid) {
      className += ' fic-input-invalid'
    }
    style = Object.assign({}, style)
    // Textarea
    if (FICInputTextTag === 'textarea' && props.lines > 0) {
      style = Object.assign({}, props.style, { height: 30 + 50 * (props.lines - 1) })
    }
    // Clearable
    if (clearable) {
      rightIcon = this.state.clearableVisible ? 'close' : null
      rightIconClick = onChange ? () => {
        const prevValue = this.uncontrolledGetValue()
        if (props.uncontrolled) {
          this.uncontrolledSetValue('')
        }
        if (prevValue !== '') {
          this.setState({ clearableVisible: false })
          this.executeOnChange('')
        }
      } : rightIconClick
    }
    // Advanced options style
    if (leftIcon) {
      Object.assign(style, { paddingLeft: 24 })
    }
    if (rightIcon) {
      Object.assign(style, { paddingRight: 24 })
    }
    leftText = leftText && (typeof leftText === 'function' ? leftText() : leftText)
    rightText = rightText && (typeof rightText === 'function' ? rightText() : rightText)

    // Display
    const value = this.getDisplayValue()
    let result = <FICInputTextTag
      type={props.inputType}
      ref={(input) => {
        this.textInput = input
      }}
      value={value}
      placeholder={props.placeholder}
      onChange={this.handleChange}
      onFocus={this.handleFocus}
      onBlur={this.handleBlur}
      onKeyPress={props.onKeyPress}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onClick={props.onClick}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
      className={className}
      maxLength={props.maxLength}
      style={style || props.style}
      disabled={props.disabled}
      autoComplete='new-password' // Disable Chrome autofill
    />
    // Advanced options wrap
    if (leftText || leftIcon || rightText || rightIcon) {
      result = <div className='fic-advanced-input-text'>
        {leftText && <span className='text-left' ref={leftText => this.leftText = leftText}>{leftText}</span>}
        {leftIcon && <FAIcon className='icon-left' name={leftIcon} onClick={leftIconClick} style={leftIconClick ? { cursor: 'pointer' } : {}} />}
        {result}
        {rightIcon && <FAIcon className='icon-right' name={rightIcon} onClick={rightIconClick} style={rightIconClick ? { cursor: 'pointer' } : {}} />}
        {rightText && <span className='text-right' ref={rightText => this.rightText = rightText}>{rightText}</span>}
      </div>
    }
    // Validator tooltip wrap
    if (props.validator) {
      result = <FICTooltip
        placement='top'
        text={props.validator.message}
        trigger={props.validator.valid ? [] : ['hover', 'focus']}
        enabled={!props.validator.valid && !!props.validator.message}>
        {result}
      </FICTooltip>
    }
    return result
  }
}

FICInputText.propTypes = {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onClick: PropTypes.func,
  maxLength: PropTypes.number,
  style: PropTypes.object,
  uncontrolled: PropTypes.bool,
  changeOnBlur: PropTypes.bool,
  changeDelay: PropTypes.number,
  lines: PropTypes.number,
  transform: PropTypes.func,
  inputType: PropTypes.string,
  disabled: PropTypes.bool,
  clearable: PropTypes.bool,
  leftIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  leftIconClick: PropTypes.func,
  leftIconHover: PropTypes.func,
  leftText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  rightIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  rightIconClick: PropTypes.func,
  rightIconHover: PropTypes.func,
  rightText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
}

FICInputText.defaultProps = {
  type: 'text',
  value: undefined,
  placeholder: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyPress: undefined,
  onKeyDown: undefined,
  onKeyUp: undefined,
  onClick: undefined,
  maxLength: undefined,
  style: {},
  uncontrolled: false,
  changeOnBlur: true,
  changeDelay: 500,
  lines: 1,
  transform: undefined,
  inputType: 'text',
  disabled: undefined,
  clearable: false,
  leftIcon: undefined,
  leftIconClick: undefined,
  leftIconHover: undefined,
  leftText: undefined,
  rightIcon: undefined,
  rightIconClick: undefined,
  rightIconHover: undefined,
  rightText: undefined
}

FICInputText.dotsToCommasTransform = value => FICNumbers.dotsToCommas(value)

export default FICInputText



// WEBPACK FOOTER //
// ./src/common/forms/js/FICInputText.js